<template>
<div class="chapter">
<div class="inner_page">
<div class="SOM">
<h1 class="SOM_titre">Contents</h1>
<div class="SOM_pre"><a href="#/pre2"><i>Acknowledgments</i></a></div>
<div class="SOM_pre"><a href="#/pre3">Introduction</a></div>
<div class="SOM_chap"><a href="#/chap1">1 On Calvinism</a></div>
<div class="SOM_chap"><span href="#/chap2" title="Link target outside of Sample">2 God’s Eternal Purpose</span></div>
<div class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample">3 Free Will and Salvation</span></div>
<div class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample">4 Calvinism and Universalism</span></div>
<div class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample">5 Calvinism and the Cross</span></div>
<div class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample">6 Calvinism and the Extent of the Atonement</span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample"><i>Conclusion</i></span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample"><i>Notes</i></span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample"><i>Index</i></span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample"><i>Praise for</i> Saving Calvinism</span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample"><i>About the Author</i></span></div>
<div class="SOM_appen"><span href="#/appen9" title="Link target outside of Sample"><i>More Titles from InterVarsity Press</i></span></div>
<div class="SOM_pdf"><span href="#/ident11#copy1" title="Link target outside of Sample"><i>Copyright Page</i></span></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?4ebfbaf8